<template>
  <div class="moreTable">
    <el-table
      ref="moreTable"
      :data="tableList"
      :span-method="objectSpanMethod"
      :max-height="630"
      :min-height="500"
      tooltip-effect="dark"
      stripe
      style="width: 100%; border-top: 1px solid #F1F4F7;"
      @cell-click="cellClick">
      <el-table-column
        v-for="(item, index) in tableHead"
        :key="index"
        :label="item.label"
        :prop="item.key"
        :min-width="item.minWidth || 120"
        :fixed="item.fixed"
        :sortable="item.isSort ? 'custom' : false"
        :show-overflow-tooltip="true">
        <el-table-column
          v-for="(elem, i) in item.children"
          :key="i"
          :label="elem.label"
          :prop="elem.key"
          :min-width="elem.minWidth || 120">
          <template slot-scope="scope">
            <div
              :class="scope.row[elem.key] && scope.row[elem.key] * 1 !== 0 ? 'table-item' : ''"
              class="f-toe"
              @click="outLink(elem, scope.row)">
              {{ scope.row[elem.key] || scope.row[elem.key] === 0 ? scope.row[elem.key] : '-' }}
              <span v-if="scope.row[elem.key + '-isShow']" class="icon-cross"></span>
              <commentDetail
                v-if="scope.row[elem.key + '-isShow']"
                :is-loading="scope.row[elem.key + '-isLoad']"
                :time-all-list="detailList"
                :time-list="showDetailList"
                scrollDom=".comment-detail-box"
                class="comment-detail-box" />
            </div>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import commentDetail from './commentDetail.vue'
// import pageConfig from './page.config.js'
export default {
  components: {
    commentDetail
  },
  props: {
    rowspanKey: {
      type: String,
      default: 'type'
    },
    tableHead: {
      type: Array,
      default: () => {
        return []
      }
    },
    tableList: {
      type: Array,
      default: () => {
        return []
      }
    },
    isLoadDetail: {
      type: Boolean,
      default: false
    },
    detailList: {
      type: Array,
      default: () => {
        return []
      }
    },
    showDetailList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      // tableHead: pageConfig.tableHead,
      rowsSpans: []
    }
  },
  watch: {
    tableList: {
      handler(newArr, oldArr) {
        this.rowsSpans = newArr.reduce((preArr, item, index) => {
          const findItem = preArr.find(elem => elem.label === item[this.rowspanKey])
          if (findItem) {
            findItem.rowspan++
            findItem.rowsIndexs.push(index)
          } else {
            preArr.push({
              key: this.rowspanKey,
              label: item[this.rowspanKey],
              startRow: index,
              rowspan: 1,
              colspan: 1,
              rowsIndexs: [index]
            })
          }
          return preArr
        }, [])
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 单元格点击事件
    cellClick(row, column, cell, $event) {
      const itemShow = row[column.property + '-isShow']
      this.tableList.forEach(item => {
        for (const key in item) {
          item[key + '-isShow'] = false
          item[key + '-isLoad'] = true
        }
        return item
      })
      if (!row[column.property] || row[column.property] + '' === '0') return
      row[column.property + '-isShow'] = !itemShow
      if (!itemShow) this.$emit('crossDetail', row, column)
    },
    // 位置展示
    mouseOver($event) {
      const clientWidth = document.documentElement.clientWidth
      const cursorX = event.pageX
      // 向下
      const cursorY = event.clientY
      const clientHeight = document.documentElement.clientHeight
      // 箭头icon
      const iconDom = $event.currentTarget.getElementsByClassName('icon-cross')
      // 内容box
      const boxDom = $event.currentTarget.getElementsByClassName('comment-detail-box')
      this.$nextTick(() => {
        const isRight = cursorX * 2 < clientWidth
        const isBottom = (cursorY + 400) > clientHeight
        if (iconDom && iconDom.length > 0) {
          const className = 'icon-cross'
          const rightClass = isRight ? 'icon-cross-right' : 'icon-cross-left'
          const btmClass = isBottom ? 'icon-cross-bottom' : 'icon-cross-top'
          iconDom[0].setAttribute('class', className + ' ' + rightClass + ' ' + btmClass)
        }
        if (boxDom && boxDom.length > 0) {
          const className = 'detail-list comment-detail-box'
          const rightClass = isRight ? 'comment-detail-box-right' : 'comment-detail-box-left'
          const btmClass = isBottom ? 'comment-detail-box-btm' : 'comment-detail-box-top'
          boxDom[0].setAttribute('class', className + ' ' + rightClass + ' ' + btmClass)
        }
      })
    },
    // 展示详情
    outLink(item, rowItem) {
      rowItem.isShow = true
      this.$emit('crossDetail', item, rowItem)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 首列合并
      if (columnIndex === 0) {
        const findItem = this.rowsSpans.find(item => item.label === row[this.rowspanKey])
        // 当前是合并属性
        if (findItem) {
          // 判断当前是否从该行开始合并，如果是则返回合并属性；如果是合并行内，则直接返回0
          if (findItem.startRow === rowIndex) {
            return {
              rowspan: findItem.rowspan,
              colspan: 1
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0
            }
          }
        } else {
          return {
            rowspan: 1,
            colspan: 1
          }
        }
      }
    }
  }
}
</script>

<style lang="less">
.moreTable{
  & .el-table--border th.el-table__cell, .el-table__fixed-right-patch,
  .el-table td.el-table__cell{
    text-align: center;
  }
}
</style>
<style lang="less" scoped>
@import '~@/assets/less/color.less';
// .table-item:hover{
//   color: @color-blue;
//   text-decoration: underline;
//   cursor: pointer;
// }
.icon-cross{
  position: absolute;
  height: 10px;
  width: 10px;
  border-left: 1px solid #ddd;
  border-top: 1px solid #ddd;
  margin-top: 6px;
  z-index: 3;
  background: #fff;
}
.icon-cross-right{
  transform: rotate(-45deg);
  right: 14px;
}
.icon-cross-left{
  transform: rotate(135deg);
  left: 13px;
}
.comment-detail-box-right{
  left: 0;
  margin-left: 100px;
}
.comment-detail-box-left{
  right: 0;
  margin-right: 100px;
}
.comment-detail-box-top{
  top: 0;
}
.comment-detail-box-btm{
  bottom: 7px;
}
.comment-detail-box{
  position: absolute;
  z-index: 2;
  width: 500px;
  min-height: 200px;
  max-height: 300px;
  text-align: left;
  overflow-x: hidden;
  padding: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
}
</style>
